import React from "react";

import about3 from "../../assets/img/about-6.jpg";

function Benefits() {
  return (
    <div class="container-xxl py-6">
      <div class="container">
        <div class="row g-5">
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div
              class="position-relative overflow-hidden ps-5 pt-5 h-100"
              style={{ minHeight: "400px" }}
            >
              <img
                class="position-absolute w-100 h-100"
                src={about3}
                alt=""
                style={{ objectFit: "cover" }}
              />
           
            </div>
          </div>
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div class="h-100">
              <h6 class="text-primary text-uppercase mb-2">Benefits</h6>

              <p>
                We strive to be unique in all services, we provide both to
                clients and employees including the benefits and perks. When you
                become a Consultant of Revtech, in essence you will be a
                full-time employee and you will gain many of the same benefits
                of a permanent employee. We continually review our benefits in
                an attempt to provide you with many of the best benefit programs
                available in the industry. At Revtech we believe our employees
                are our most valuable asset. We also believe that benefits are
                an extremely important part of an employment relationship.
              </p>           
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Benefits;
